import { LabelProps, ResponsiveCirclePacking } from '@nivo/circle-packing';

import { BubbleData, PieData } from '../types';
import React from 'react';
import { useThemeContext } from '../../../context/Theme';
import { measureTextPxWidth } from '../../../helpers/dom';

const BubbleLabel = ({ label, style, node }: LabelProps<BubbleData>) => {
  const { theme } = useThemeContext();

  const bubbleSize = node.radius * 2;
  const textSize = measureTextPxWidth(label.toString(), 16);

  return (
    <text
      x={node.x}
      y={node.y}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        fontSize: '16px',
        fontWeight: 500,
        textTransform: 'capitalize',
        pointerEvents: 'none',
        color: theme === 'DARK' ? '#FFF' : '#121212',
      }}
    >
      {textSize < bubbleSize ? label : ''}
    </text>
  );
};

export const Bubble = ({
  className,
  bubbleData,
}: {
  className: string;
  bubbleData: BubbleData;
}) => {
  return (
    <div className={className}>
      <div
        className={`
          absolute
          top-0
          bottom-0
          left-0
          right-0
          oveflow-hidden
          bg-center
          z-20
        `}
      >
        <ResponsiveCirclePacking
          inheritColorFromParent={true}
          animate={false}
          labelsSkipRadius={20}
          labelComponent={(labelProps) => <BubbleLabel {...labelProps} />}
          data={bubbleData}
          id="id"
          colors={({ data }) => (data as unknown as PieData).color}
          value="value"
          leavesOnly
          padding={8}
          enableLabels
          tooltip={({ id, formattedValue, color }) => {
            return (
              <div
                className={
                  'flex bg-white px-3 py-2 rounded-md border-1 border-grey-30 dark:bg-grey-90 dark:border-grey-80 bg-black-backdrop items-center'
                }
              >
                <div
                  className={`flex h-5 w-2 dark:bg-grey-90 rounded-sm gap-2`}
                />
                <div
                  className={'w-5 h-5 mr-3'}
                  style={{ background: color }}
                ></div>
                <div className={'flex dark:text-white'}>
                  {id}: {formattedValue}
                </div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};
